import SubHeaders from '@/components/Headers/SubHeaders'
import useTabs from '@/hooks/useTabs'
import { paths } from '@/utils/path'
import { useTranslation } from 'react-i18next'
import { Tabs } from 'vnetwork-ui'
import ClosingSoon from './ClosingSoon'
import HeartIcons from '@/icons/HeartIcons'
import ReceiptIcons from '@/icons/ReceiptIcons'
import SearchIcons from '@/icons/SearchIcons'
import { ThumbsDown } from 'lucide-react'
import TenderListView from './tender-list-view'
import TenderSearch from './TenderSearch'

const TendersList = () => {
    const { t } = useTranslation('tenders')

    const tabs = [
        {
            label: t('new'),
            value: 'tenders-new',
            startIcon: <ReceiptIcons className="text-bg-primary" />,
            component: <TenderListView variant="new" />,
        },
        {
            label: t('following'),
            value: 'tenders-following',
            startIcon: <HeartIcons className="text-bg-primary" />,
            component: <TenderListView variant="following" />,
        },
        {
            label: t('unfollowed'),
            value: 'tenders-unfollowed',
            startIcon: <ThumbsDown className="size-4 text-bg-primary" />,
            component: <TenderListView variant="unfollowed" />,
        },
        {
            label: t('search.tab'),
            value: 'tenders-search',
            startIcon: <SearchIcons className="text-bg-primary" />,
            component: <TenderSearch />,
        },
    ]

    const { TabComponent, TabProps } = useTabs({
        tabs: tabs,
    })

    return (
        <div>
            <SubHeaders
                breadcrumbs={[{ title: t('title'), path: paths.tenders }]}
            />

            <Tabs {...TabProps} />
            <ClosingSoon />
            {TabComponent}
        </div>
    )
}

export default TendersList
